export default class CompanySettingsController {
    /** @ngInject */
    constructor(EventEmitter) {
        this.eventEmiter = EventEmitter;
    }
}



// WEBPACK FOOTER //
// ./app/components/company-settings/company-settings.controller.js